import type { ExportDataColumn, ExportParams, PdfTemplate } from './helpers'
import { createPDFDocument } from '~/pdfs/helpers'
import generateDefaultPdfSections from '~/pdfs/templates/generateDefaultPdfSections'
import generatePersonDetailsPdfSections from '~/pdfs/templates/generatePersonDetailsPdfSections'

export default async (columns?: ExportDataColumn[], data?: any[], params?: ExportParams, template?: PdfTemplate) => {
  if (template === 'personDetails' && params?.template?.personId) {
    const personDetails = await generatePersonDetailsPdfSections(params)
    return createPDFDocument(personDetails)
  } else {
    return createPDFDocument(generateDefaultPdfSections(columns, data, params))
  }
}
